var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"text-page"}},[_c('h1',{staticClass:"page-title txt-black"},[_vm._v("PRIVACY, CONFIDENTIALITY, AND SECURITY POLICY")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacy.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }